<script setup lang="ts">
import { type IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@teemill/components';
import { computed } from 'vue';
import { type RouteLocationRaw, useRoute, useRouter } from 'vue-router';

export interface Item {
  title: string;
  to: RouteLocationRaw;
  icon?: IconDefinition;
  items?: Item[];
  order: number;
}

const route = useRoute();
const router = useRouter();

const props = defineProps<{
  items: Item[];
}>();

const sortedItems = computed(() =>
  [...props.items]
    ?.sort((a, b) => a.order - b.order)
    .filter((i) => i.icon)
    .slice(0, 5),
);

const isActive = (item: Item) => {
  const routePath = route.path.replace(/\/$/, '');
  const itemPath = router.resolve(item.to).path.replace(/\/$/, '');

  return routePath === itemPath;
};
</script>

<template>
  <div
    class="flex fixed bottom-0 left-0 right-0 bg-[--tml-navbar-background-color] shadow-[0_0_8px_-2px_rgba(0,0,0,0.3)] backdrop-blur-md"
  >
    <div
      v-for="item in sortedItems"
      :key="item.title"
      :to="item.to"
      class="flex py-4 justify-center basis-full hover:bg-[--tml-navbar-hover-background-color]"
      :class="{
        [isActive(item) ? '!text-[--tml-primary-color]' : '!text-[--tml-navbar-text-color]']: true,
      }"
    >
      <FontAwesomeIcon v-if="item.icon" :icon="item.icon" size="lg" />
    </div>
  </div>
</template>
